import cabinetStyle from "./MentorCabinet.module.css";
import phoneNumberStyle from "./MentorPhoneNumber.module.css"
import Style from "../Style.module.css";
import React, {useState} from "react";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as UserService from "../../api/UserService";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import ua from 'react-phone-number-input/locale/ua'
import {useTranslation} from "react-i18next";

export default function MentorPhoneNumber() {

    const [phoneData, setPhoneData] = useState()
    const [phoneValue, setPhoneValue] = useState()
    const [phoneEdit, setPhoneEdit] = useState(false)
    const [verificationCode, setVerificationCode] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [buttonsDisabled, setButtonsDisabled] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'mentorPhoneNumber' });

    function callCurrentPhoneNumber() {

        UserService.getCurrentMentorPhoneNumber(
            (r) => {
                setButtonsDisabled(false)
                setPhoneData(r)
            },
            () => window.alert(t('errorOnPhoneNumber'))
        )
        setPhoneEdit(false)
    }

    function userFriendlyVerificationStatus(status) {
        switch (status) {
            case "pending":
                return t('needsConfirmation')
            case "requested":
                return t('codeSent')
            case "verified":
                return t('confirmed')
            case "suspicious":
                return t('confirmationImpossible')
        }
    }

    function phoneFontColor(status) {
        switch (status) {
            case "pending":
                return "orange"
            case "requested":
                return "orange"
            case "verified":
                return "green"
            case "suspicious":
                return "red"
        }
    }

    function handleVerificationCodeChange(e) {
        if (e.target.value.match("^[0-9]{0,8}$")) {
            setVerificationCode(e.target.value)
        }
    }

    function handleErrorResponse(errorResponse) {
        setButtonsDisabled(false)
        callCurrentPhoneNumber()
        if (errorResponse.status === 400 || errorResponse.status === 429) {
            errorResponse.json().then(r => {
                switch (r.error) {
                    case "code_incorrect":
                        setErrorMessage(t('incorrectCode'))
                        break
                    case "number_suspicious":
                        setErrorMessage(t('confirmationNotPossible'))
                        break
                    case "number_required":
                        setErrorMessage(t('numberRequired'))
                        break
                    case "number_already_used":
                        setErrorMessage(t('numberAlreadyExist'))
                        break
                    case "no_phone_number":
                        setErrorMessage(t('insertNumber'))
                        break
                    case "wait_10_minutes":
                        setErrorMessage(t('wait10min'))
                        break
                    case "wait_24_hours":
                        setErrorMessage(t('wait24h'))
                        break
                    case "number_already_failed":
                        setErrorMessage(t('numberAlreadyFailed'))
                        break
                    default:
                        setErrorMessage(t('confirmationError'))
                }
            })
        }
        else {
            setErrorMessage(t('defaultError'))
        }


    }

    useEffectOnce(() => callCurrentPhoneNumber())

    return <div className={`${cabinetStyle.commonTile} ${cabinetStyle.profileSecurityPage} ${phoneNumberStyle.container}` } >
        <div className={cabinetStyle.profileTopRow}>
            <div className={Style.h5Heading}>{t('phoneNumber')}</div>
        </div>
        {errorMessage && <div className={phoneNumberStyle.errorMessage}>{errorMessage}</div>}
        {(!phoneData?.phone_number || phoneEdit)  &&
            <div className={phoneNumberStyle.phoneNumberInputContainer}>
                <PhoneInput
                    className={phoneNumberStyle.phoneNumberInput}
                    international
                    defaultCountry="UA"
                    countryCallingCodeEditable={false}
                    labels={ua}
                    value={phoneValue}
                    onChange={e => {
                        setPhoneValue(e)
                    }}
                    countries={['AC', 'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GT', 'GU', 'GW', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TA', 'TC', 'TD', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'XK', 'YE', 'YT', 'ZA', 'ZM', 'ZW']}
                    focusInputOnCountrySelection={true}
                    addInternationalOption={false}
                    countryOptionsOrder={["UA", "DE", "PL", "US", "GB", "CA", "FR", "ES", "RO", "TR", "MD", "BG", "SK", "SI", "HU", "SZ", "AT", "IT", "PT", "|", '…']}

                />
                <div
                    className={buttonsDisabled ? phoneNumberStyle.saveNumberButtonDisabled : phoneNumberStyle.saveNumberButton}
                    onClick={() => {
                        setButtonsDisabled(true)
                        setErrorMessage("")
                        UserService.postMentorPhoneNumber(phoneValue, callCurrentPhoneNumber, handleErrorResponse)
                    }}
                > {t('saveButton')} </div>
                {phoneEdit &&
                    <div
                        className={phoneNumberStyle.cancelButton}
                        onClick={() => setPhoneEdit(false)}
                    > {t('cancelButton')} </div>
                }
            </div>
        }
        {phoneData && phoneData.phone_number && !phoneEdit &&
            <div className={phoneNumberStyle.phoneNumberContainer}>
                <div style={{fontWeight: "bold"}}>{phoneData.phone_number}</div>
                <div
                    style={{fontWeight: "bold", color: phoneFontColor(phoneData.verification_status)}}
                >{t('status')} {userFriendlyVerificationStatus(phoneData.verification_status)}</div>
                {phoneData.verification_status === "pending" &&
                    <div
                        className={buttonsDisabled ? phoneNumberStyle.sendConfirmationCodeButtonDisabled : phoneNumberStyle.sendConfirmationCodeButton}
                        onClick={() => {
                            setButtonsDisabled(true)
                            UserService.requestSendVerificationSMS(
                                () => {
                                    setButtonsDisabled(false)
                                    setErrorMessage("")
                                    callCurrentPhoneNumber()
                                },
                                handleErrorResponse
                            )
                        }}
                    > {t('sendCode')}</div>
                }
                {phoneData.verification_status === "requested" &&
                    <>
                        <div>{t('enterCode')}</div>
                        <input className={phoneNumberStyle.condeInput} type="text" inputMode={"numeric"} value={verificationCode} onChange={handleVerificationCodeChange}/>
                        <div
                            className={buttonsDisabled ? phoneNumberStyle.confiremNumberButtonDisabled : phoneNumberStyle.confiremNumberButton}
                            onClick={() => {
                                setButtonsDisabled(true)
                                UserService.submitVerificationSMS(
                                    verificationCode,
                                    () => {
                                        setButtonsDisabled(false)
                                        setErrorMessage("")
                                        callCurrentPhoneNumber()
                                    },
                                    handleErrorResponse
                                )
                            }}
                        > {t('confirm')} </div>
                        <div
                            className={buttonsDisabled ? phoneNumberStyle.changeNumberButtonDisabled : phoneNumberStyle.changeNumberButton}
                            onClick={() => {
                                setButtonsDisabled(true)
                                UserService.requestSendVerificationSMS(
                                    () => {
                                        setButtonsDisabled(false)
                                        setErrorMessage("")
                                        callCurrentPhoneNumber()
                                    },
                                    handleErrorResponse
                                )
                            }}
                        > {t('sendCodeAgain')}</div>
                    </>
                }
                <div
                    className={buttonsDisabled ? phoneNumberStyle.changeNumberButtonDisabled : phoneNumberStyle.changeNumberButton}
                    onClick={() => setPhoneEdit(true)}
                > {t('changePhoneNumber')}</div>
            </div>

        }
    </div>
}